import { ApiError } from './api.js';

/**
 * What to show the owner when something failed.
 *
 * An `ApiError` carries a message the server wrote for a person to read —
 * "TikTok login expired. Reconnect @handle in Accounts." — so it is used as
 * is. Anything else is a network fault, a parse error or a bug, none of which
 * has a sentence worth showing, so it gets a fallback that says what to do
 * next rather than what broke (PLAN §13.1).
 *
 * This was hand-copied into three screens before it lived here, already with
 * two slightly different fallbacks. `fallback` keeps the one place a caller
 * genuinely needs its own wording.
 */
export function messageOf(error: unknown, fallback = 'That did not work. Try again.'): string {
  return error instanceof ApiError ? error.message : fallback;
}
